import { selectTotalCount } from '../createEagGridStore';
import { useEagGridSelector } from '../useEagGridSelector';
export function useGridTotalCount(): number {
  return useEagGridSelector(selectTotalCount);
}